import { Routes } from '@angular/router';
import { AuthAuthorizationGuard, AuthGuard } from './core/guards';
import { AuthComponent } from './pages/auth/auth.component';
import { MainComponent } from './pages/main/main.component';
import { NoAutorizadoComponent } from './pages/no-autorizado/no-autorizado.component';
import { HomeComponent } from './pages/home/home.component';
import { ListProcessComponent } from './pages/centralization/list-process/list-process.component';
import { CostCenterComponent } from './pages/centralization/cost-center/cost-center.component';
import { CreateNormalProcessComponent } from './pages/centralization/create-normal-process/create-normal-process.component';
import { CreateSpecialProcessComponent } from './pages/centralization/create-special-process/create-special-process.component';
import { ProcessSummaryComponent } from './pages/centralization/process-summary/process-summary.component';
import { LoginComponent } from './pages/login/login.component';
import { ListAuditoriaComponent } from './pages/auditoria/list-auditoria/list-auditoria.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  { path: 'login', component: LoginComponent },

  {
    path: '',
    component: MainComponent,
    children: [
      { path: 'home', component: HomeComponent },
      {
        path: 'process-list',
        component: ListProcessComponent,
        data: { permission: 11 },
        canActivate: [AuthGuard, AuthAuthorizationGuard],
        canLoad: [AuthGuard]
      },
      {
        path: 'cost-center', component: CostCenterComponent, data: { permission: 12 },
        canActivate: [AuthGuard, AuthAuthorizationGuard],
        canLoad: [AuthGuard]
      },
      {
        path: 'process/normal-process', component: CreateNormalProcessComponent, data: { permission: 3 },
        canActivate: [AuthGuard, AuthAuthorizationGuard],
        canLoad: [AuthGuard]
      },
      {
        path: 'process/special-process', component: CreateSpecialProcessComponent, data: { permission: 3 },
        canActivate: [AuthGuard, AuthAuthorizationGuard],
        canLoad: [AuthGuard]
      },
      {
        path: 'process/process-detail/:id/:type', component: ProcessSummaryComponent,
        canActivate: [AuthGuard],
        canLoad: [AuthGuard]
      },
            {
        path: 'auditoria-list',
        component: ListAuditoriaComponent,
        data: { permission: 11 },
        canActivate: [AuthGuard, AuthAuthorizationGuard],
        canLoad: [AuthGuard]
      },
    ],
  },

  { path: 'no-autorizado', component: NoAutorizadoComponent },
  { path: '**', redirectTo: 'login' },
];
